import { useMessageContext } from '@post-office/message-context';
import { useMessageInstanceEvent } from '@post-office/message-instance-event-frontend-client';
import { useMessageEvent } from '@post-office/message-lifecycle';
import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl-next';

import { createRender } from './types';

const TEST_CONTENT = (
	<FormattedMessage
		id="test-messages.app-switcher-discovery-section.test-content"
		defaultMessage="This is a test message."
		description="Test message content for app-switcher-discovery-section"
	/>
);

export const render = createRender(({ onDismissed }) => {
	const { messageInstanceId } = useMessageContext();
	const { messageDismissed } = useMessageEvent();
	const { messageInstanceClicked } = useMessageInstanceEvent();
	const handleOnClick = useCallback(async () => {
		if (messageInstanceId) {
			await messageDismissed();
			await messageInstanceClicked({
				messageEventType: 'clicked',
				clickedElement: {
					clickIdentifier: 'dismiss',
					clickedElement: 'button',
					buttonType: 'primary',
				},
				action: {
					actionType: 'dismiss',
				},
				additionalMetadataFromFrontend: {},
			});
			onDismissed(messageInstanceId);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [messageInstanceId, messageDismissed, messageInstanceClicked]);

	return (
		<div>
			<p>{TEST_CONTENT}</p>
			<button onClick={handleOnClick}>
				<FormattedMessage
					id="test-messages.app-switcher-discovery-section.dismiss"
					defaultMessage="Dismiss"
					description="Dismiss test message template"
				/>
			</button>
		</div>
	);
});

export default render;
